import React, { useEffect, useState } from 'react'
import {
  Form,
  Input,
  Select,
  Switch,
  Button,
  Card,
  Row,
  Col,
  Modal,
  message,
  Checkbox,
} from 'antd'
import { PlusOutlined, MinusOutlined, InboxOutlined } from '@ant-design/icons'
import styles from './Step2.module.css'
import { clearAllCookies } from '../../../../util/handleObject'
import Cookies from 'js-cookie'
import Dragger from 'antd/es/upload/Dragger'
import excelUtilNew from '../../../../util/excelUtilNew'
import * as XLSX from 'xlsx'
import excelUtil from '../../../../util/excelUtil'

const { TextArea } = Input
const Step2 = (props) => {
  const [fileList, setFileList] = useState([])
  const [excelFile, setExcelFile] = useState(null)
  useEffect(() => {}, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  const customRequest = async (options) => {
    const { onSuccess, onError, file } = options
    onSuccess(file)

    // try {
    //   // 使用阿里云OSS SDK上传文件
    //   let timestamp = new Date().getTime()
    //   let random = getSixMathRandom()
    //   const result = await client.put(
    //     ALI_OSS_PATH + 'meetingSummary/' + timestamp + random + file.name,
    //     file,
    //   )
    //   file.url = result.url.replace('http:', 'https:')
    //   onSuccess(file)
    //   setIsLoading(false)
    // } catch (e) {
    //   message.error(`文件上传失败`)
    //   setIsLoading(false)
    //   onError(e)
    // }
  }
  function handleChange(info) {
    // return;

    if (info.fileList.length === 0) {
      setFileList([])
      return
    } else {
      setFileList([info.fileList.pop()])
    }
    const { status } = info.file
    if (status !== 'uploading') {
      console.log(info.file, info.fileList)
    }
    if (status === 'done') {
      // message.success(`${info.file.name} 文件上传成功.`)
    } else if (status === 'error') {
      // message.error(`${info.file.name} 文件上传失败.`)
    }
  }
  const props1 = {
    name: 'file',
    accept: '.xls,.xlsx',
    multiple: false,
    // previewFile:true,
    customRequest: customRequest,
    onChange: handleChange,
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files)
    },
    beforeUpload(file) {
      const fileSize = file.size / 1024 / 1024 < 24
      if (!fileSize) {
        message.error('视频文件必须小于24MB!')
        return false
      }
      setExcelFile(file)
      // 通过FileReader对象读取文件
      return true
    },
    fileList: fileList,
  }

  return (
    <div>
      <Dragger {...props1} className={styles.topContainer}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">拖拽文件到此处或点击上传</p>
        <p className="ant-upload-hint">
          支持.xls或.xlsx格式，文件大小不超过20MB
        </p>
      </Dragger>
      <div className={styles.bottomContainer}>
        <div className={styles.bottomTitle}>模板填写说明：</div>
        <div className={styles.bottomDesc}>
          1. 请严格按照模板格式填写，确保数据的准确性。
          <br />
          2. 请勿修改模板结构，否则可能导致导入失败。
          <br />
          3. 账号开通后，<span style={{ color: '#000', fontWeight: 'bold' }}>登录账号为手机号，初始密码为
          000000。</span>
          为保障账户安全，请在首次登录后立即修改密码。
          <br />
          4.
          “身份”与“授课年级”列仅需填写一个主要身份，请勿填写多个身份，否则可能导致导入失败。
        </div>
      </div>
      <div className={styles.bottomButton}>
        <Button
          color="default"
          variant="outlined"
          style={{ marginLeft: '820px' }}
          onClick={() => {
            props.prevStep()
          }}
        >
          上一步
        </Button>
        <Button
          type="primary"
          style={{ marginLeft: '20px' }}
          onClick={() => {
            if (fileList.length === 0) {
              message.error('请上传文件')
              return
            }
            props.nextStep(excelFile)
          }}
        >
          下一步
        </Button>
      </div>
    </div>
  )
}

export default Step2
